<template>
  <div class="w-full bg-white">
    <div class="w-full h-20 bg-panels-gradient">
      <ul class="h-20 flex overflow-x-auto">
        <li
          class="mx-3 md:mx-6 flex flex-row flex-none"
          v-is-authorized="{ roles: [$store.getters.getUserRole], permissions: ['can_upload'] }"
        >
          <router-link
            :to="{name: 'upload', params: {vault_id: currentVault.id}}"
            active-class="border-brand"
            class="h-full border-b-4 border-transparent hover:border-brand no-underline whitespace-no-wrap text-grey-darkest uppercase text-center font-semibold text-xs md:text-base flex items-center"
          >Upload Documents</router-link>
        </li>
        <li
          class="mx-3 md:mx-6 flex flex-row flex-none"
          v-is-authorized="{ roles: [$store.getters.getUserRole], permissions: ['can_file_document', 'can_tag_document'] }"
        >
          <router-link
            :to="{name: 'tagging', params: {vault_id: currentVault.id}}"
            active-class="border-brand"
            class="h-full border-b-4 border-transparent hover:border-brand no-underline whitespace-no-wrap text-grey-darkest uppercase text-center font-semibold text-xs md:text-base flex items-center"
          >
            File &amp; Tag
            <!-- Inside the link so the active underline and focus ring cover the count too -->
            <span
              class="bg-brand text-white rounded-full w-6 h-6 md:w-8 md:h-8 flex items-center justify-center ml-2 text-xs md:text-base font-semibold"
              v-show="unfiled > 0"
            >{{unfiled}}</span>
          </router-link>
        </li>
        <li class="mx-3 md:mx-6 flex flex-row flex-none">
          <router-link
            :to="{name: 'recently-filed', params: {vault_id: currentVault.id}}"
            active-class="border-brand"
            class="h-full border-b-4 border-transparent hover:border-brand no-underline whitespace-no-wrap text-grey-darkest uppercase text-center font-semibold text-xs md:text-base flex items-center"
          >Recently Filed</router-link>
        </li>
      </ul>
    </div>
    <router-view class="w-full h-full p-3" @update-unfiled="updateUnfiled"></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      unfiled: ""
    };
  },

  beforeDestroy() {
    this.$store.commit("resetRecentFiles", []);
  },

  mounted() {
    this.getUnfiled();

    this.$ebus.$on("refresh-unfiled", () => {
      this.getUnfiled();
    });
  },

  methods: {
    getUnfiled() {
      if (!_.isEmpty(this.$route.params)) {
        axios
          .get(`/api/vaults/${this.$route.params.vault_id}/files/for-tagging`, {
            params: {
              mine_only: 1
            }
          })
          .then(({ data }) => {
            this.unfiled = data.total;
          });
      }
    },
    updateUnfiled(payload) {
      this.unfiled = payload;
    }
  },

  computed: {
    ...mapGetters({
      currentVault: "getCurrentVault"
    })
  }
};
</script>

<style>
</style>
